const LOCAL_API_BASE_URL = 'http://127.0.0.1:5001/api';
const LIVE_RENDER_API_BASE_URL = 'https://crypto-trading-app-4l1k.onrender.com/api';

function normalizeApiBaseUrl(value) {
  return value.replace(/\/+$/, '');
}

function resolveDefaultApiBaseUrl() {
  if (typeof window === 'undefined') {
    return LIVE_RENDER_API_BASE_URL;
  }

  const host = window.location.hostname;

  if (host === 'localhost' || host === '127.0.0.1') {
    return LOCAL_API_BASE_URL;
  }

  return LIVE_RENDER_API_BASE_URL;
}

function deriveSocketServerUrl(apiBaseUrl) {
  return apiBaseUrl.replace(/\/api$/, '');
}

const apiBaseUrl = normalizeApiBaseUrl(
  process.env.REACT_APP_API_BASE_URL || resolveDefaultApiBaseUrl(),
);

const socketServerUrl =
  process.env.REACT_APP_SOCKET_SERVER_URL || deriveSocketServerUrl(apiBaseUrl);

export const env = {
  apiBaseUrl,
  socketServerUrl,
  enableRealtime: process.env.REACT_APP_ENABLE_REALTIME === 'true',
};
